import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, Type, ViewChild } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';
import { ProductsService } from 'src/app/services/products.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { ServiceTypeService } from 'src/app/services/service-type.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { WorkshopJobcardCreateCollectionComponent } from './workshop-jobcard-create-collection/workshop-jobcard-create-collection.component'
import { WorkshopJobcardManageCollectionsComponent } from './workshop-jobcard-manage-collections/workshop-jobcard-manage-collections.component';
import { WorkshopJobcardSaveToCollectionComponent } from './workshop-jobcard-save-to-collection/workshop-jobcard-save-to-collection.component';
import { WorkshopJobcardCreateSkuComponent } from './workshop-jobcard-create-sku/workshop-jobcard-create-sku.component';
import { HubInputComponent } from 'src/app/components/ui-components/hub-input/hub-input.component';
import { WorkshopJobcardCreateService } from '../workshop-jobcard-create.service';
import { WorkshopJobcardQuoteComponent } from '../workshop-jobcard-quote/workshop-jobcard-quote.component';
import { WorkshopJobcardQuoteService } from '../workshop-jobcard-quote/workshop-jobcard-quote.service';
import { MessageService } from 'primeng/api';
import moment from 'moment';
import { ServiceRequestService } from 'src/app/services';


// import {EditLineItemComponent} from "./edit-line-item-modal/edit-line-item.component";
// import {EditLineNoteComponent} from "./edit-line-note-modal/edit-line-note.component";

@Component({
  selector: 'app-workshop-jobcard-quote-search-area',
  templateUrl: './workshop-jobcard-quote-search-area.component.html',
  styleUrls: ['./workshop-jobcard-quote-search-area.component.scss'],
  providers: [MessageService]
})
export class WorkshopJobcardQuoteSearchAreaComponent implements OnChanges {

  @Input() jobcard: any;
  @Input() serviceTypes: any[] = [];
  @Input() productSKUServiceTypeCollection: any = [];
  @Input() hideSearchSummary: boolean = false;
  @Output() jobcardChange = new EventEmitter<any>();

  public searchProductTerm: string = '';
  private searchSubject = new Subject<string>();
  public couponCode = ''
  public hasCoupon = false
  public itemAtShop = false;
  public showBaytagInput = true
  public exInOptions: any[] = [{ value: 'INTERNAL', 'label': this.translate.instant("bikeshop.workshop.jobcard.quote.internal") }, { value: 'EXTERNAL', label: this.translate.instant("bikeshop.workshop.jobcard.quote.external") }];
  public isExInOpen = false;
  public selectedExInOption: any = this.exInOptions[0];
  public isQuantityloading = false
  public selectedLineItems: any = [];
  public displayLineItems: any = [];
  public isProductsloading = false;
  public lineItemResults: any = [];
  public serviceTypeList: any = [];
  public serviceTypeResults: any = [];
  public serviceTypeGroups: any = [];
  public canDoExternalSearch: boolean = false;
  public priceGroups: any = [];
  public priceGroup: any;
  public lightSpeedDiscounts: any = [];
  public hasPOSConnected: boolean = false;
  public collections = [];
  public createdCollections = [];
  public selectedCollection: any = null;
  public selectedCollectionData: any = [];
  public canCreateSKU: boolean = false;  

  public getQuantitiesLocked: boolean = false;

  public searchTriggerLength: number = 2;

  public partnerData: any = {};
  public currencySymbol: string = "$";
  public vatInclusive: boolean = true;
  public syncingPOS: boolean = false;
  public showCreatePOSProduct: boolean = false;


  visibleCollections: any[] = [];
  overflowCollections: any[] = [];
  showOverflow = false;
  showCreateCollectionButton = true;
  createCollectionButtonWidth: number = 0;

  @ViewChild('collectionContainer', { static: false }) collectionContainerRef!: ElementRef;
  @ViewChild('collectionItems', { static: false }) collectionItemsRef!: ElementRef;
  @ViewChild('createCollectionButton', { static: false }) createCollectionButtonRef!: ElementRef;
  @ViewChild('searchBar', { static: true }) searchBar!: HubInputComponent;
  @ViewChild('searchAreaContainer', { static: false }) searchAreaContainerRef!: ElementRef;
  @ViewChild(WorkshopJobcardQuoteComponent) quoteComponent!: WorkshopJobcardQuoteComponent;

  private resizeHandler = () => this.calculateVisibleCollections();

  constructor(
    private productsService: ProductsService,
    private invoiceService: InvoiceService,
    private helpersService: HelpersService,
    private serviceTypeService: ServiceTypeService,
    private modalService: NgbModal,
    private translate: TranslateService,
    public workshopJobcardCreateService: WorkshopJobcardCreateService,
    private workshopJobcardQuoteService: WorkshopJobcardQuoteService,
    private messageService: MessageService,
    private serviceRequest: ServiceRequestService
  ) {
    this.partnerData = this.helpersService.getPartnerData();
    this.currencySymbol = this.partnerData?.CurrencySymbol || '$';
    this.vatInclusive = this.partnerData?.VATInclusive;
  }

  // Listen for clicks anywhere on the document
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Check if search results are showing
    if (this.hasSearchResults() && this.searchAreaContainerRef) {
      // Check if the click was outside the search area container
      const clickedInside = this.searchAreaContainerRef.nativeElement.contains(event.target as Node);

      // Also check if clicked on dropdown menus or modal overlays (to prevent closing when interacting with UI)
      const clickedOnDropdown = (event.target as Element)?.closest('.custom-dropdown, .overflow-dropdown, .dropdown-menu-options');
      if (!clickedInside && !clickedOnDropdown && !this.getQuantitiesLocked) {
        // Close search results by clearing the search term
        this.clearSearchResults();
      }
    }
  }

  // Check if search results are currently showing
  hasSearchResults(): boolean {
    return !this.isProductsloading && (this.getFilteredSKUs().length > 0 || this.serviceTypeResults.length > 0);
  }

  // Clear search results
  clearSearchResults() {
    this.lineItemResults = [];
    this.serviceTypeResults = [];
    this.serviceTypeList = [];
    this.searchProductTerm = '';
    if (this.searchBar) {
      this.searchBar.value = '';
    }
    this.collectionSelected({ id: 'ALL', collectionName: this.translate.instant("general.all") });
  }

  ngOnInit() {
    this.setFlags();
    this.getCollections();
    this.getItemPricesGroups();

    this.searchSubject
      .pipe(debounceTime(500)) // Delay API call by 500ms
      .subscribe((searchValue) => {
        if (searchValue.length > this.searchTriggerLength) {
          this.isProductsloading = true;
          this.searchAPI(searchValue);
        }
      });
    this.searchBar.autofocus = true;
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['productSKUServiceTypeCollection']) {
      if (this.productSKUServiceTypeCollection && this.productSKUServiceTypeCollection.length >= 0) {
        var serviceTypeCollection = this.collections.find(col => col.id === 'SERVICE_TYPE');
        if (serviceTypeCollection) {
          serviceTypeCollection.count = this.productSKUServiceTypeCollection.length;
        }
      }
    }
  }

  calculateVisibleCollections() {
    this.showCreateCollectionButton = true;
    const containerWidth = this.collectionContainerRef?.nativeElement?.offsetWidth || 0;
    const buttonWidth = this.createCollectionButtonRef ? this.createCollectionButtonRef.nativeElement.offsetWidth : 0;
    this.createCollectionButtonWidth = Math.max(this.createCollectionButtonWidth, buttonWidth);
    const items: HTMLElement[] = Array.from(this.collectionItemsRef?.nativeElement?.querySelectorAll('.collection-items > div:not(.overflow-button)'));
    let usedWidth = 0;
    let visibleCount = 0;

    for (let i = 0; i < this.collections.length; i++) {
      const el = items[i];
      if (!el) break;

      usedWidth += el.offsetWidth;
      if (usedWidth + 90 > containerWidth) {
        this.showCreateCollectionButton = false;
        break;
      }
      if (usedWidth + this.createCollectionButtonWidth > containerWidth) {
        this.showCreateCollectionButton = false;
      }

      visibleCount++;
    }

    this.visibleCollections = this.collections.slice(0, visibleCount);
    this.overflowCollections = this.collections.slice(visibleCount);
  }

  setFlags() {
    var partner = this.helpersService.getPartnerData();
    this.canDoExternalSearch = this.jobcard.id &&
      (partner.POSSystemID === 6 || partner.POSSystemID === 9) &&
      partner.ExternalProductIntegrationsPartnerLinks &&
      partner.ExternalProductIntegrationsPartnerLinks.length > 0;

    this.hasPOSConnected = partner.POSSystemID > 0 && partner.POSSystemID !== null;

    this.canCreateSKU = partner.POSSystemID <= 0 || (partner.POSSystemID === 6 && partner.AllowSKUCreationFromJobCard);
  }


  getCollections() {
    this.collections = [];
    this.invoiceService.getProductCollections(this.helpersService.getPartnerId()).subscribe((result) => {

      this.createdCollections = result;

      if (this.serviceTypes && this.serviceTypes.length >= 0) {
        this.collections.push({
          id: 'SERVICE_TYPE',
          collectionName: this.translate.instant("bikeshop.menu.service_types"),
          count: this.serviceTypes.length
        });
      }

      result.forEach((collection) => {
        this.collections.push({
          id: collection.id,
          collectionName: collection.collectionName,
          count: collection.count || 0
        });
      });

      if (this.collections.length > 0) {
        this.collections.unshift({
          id: 'ALL',
          collectionName: this.translate.instant("general.all"),
          selected: this.selectedCollection && this.selectedCollection.id ? false : true
        })
      }
      this.visibleCollections = this.collections;
      this.overflowCollections = [];

      if (this.selectedCollection && this.selectedCollection.id) {
        const selected = this.collections.find(col => col.id === this.selectedCollection.id);
        selected.selected = true;
      }

      setTimeout(() => this.calculateVisibleCollections(), 100);
      window.addEventListener('resize', this.resizeHandler);

    });
  }

  canGetQuantitiesFromPOS() {
    return this.partnerData?.POSSystemID === 6 && this.selectedExInOption.value === 'INTERNAL';
  }

  toggleDropdown() {
    this.isExInOpen = !this.isExInOpen;
  }

  selectOption(option: string) {
    this.selectedExInOption = option;
    this.isExInOpen = false;
    this.lineItemResults = [];
    this.serviceTypeResults = [];
    this.serviceTypeList = [];

    if (this.selectedExInOption.value === 'EXTERNAL') {
      this.collectionSelected({ id: 'ALL', collectionName: this.translate.instant("general.all") });
    }

    if (this.searchProductTerm && this.searchProductTerm.length >= this.searchTriggerLength) {
      this.searchAPI(this.searchProductTerm);
    }
  }

  createCollection(sku = null) {
    const modalRef = this.modalService.open(WorkshopJobcardCreateCollectionComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window'
    });
    modalRef.componentInstance.sku = sku;

    modalRef.result.then(
      (result) => {
        this.getCollections();
      },
      (onrejected) => {
        this.getCollections();
      },
    );
  }

  manageCollections() {
    const modalRef = this.modalService.open(WorkshopJobcardManageCollectionsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window'
    });

    modalRef.componentInstance.collections = this.createdCollections;

    modalRef.result.then(
      (result) => {
        this.getCollections();
      },
      (onrejected) => {
        this.getCollections();
      },
    );
  }

  collectionSelected(collection) {
    this.searchBar.value = '';
    this.collections.forEach((col) => {
      if (col.id === collection.id) {
        col.selected = true;
      } else {
        col.selected = false;
      }
    });
    this.getCollectionSkus(collection);
  }

  isInCustomCollection() {
    var inCollection = false;
    if (this.selectedCollection && this.selectedCollection.id && this.selectedCollection.id != 'ALL' && this.selectedCollection.id != 'SERVICE_TYPE') {
      inCollection = true;
    }
    return inCollection;
  }

  getCollectionSkus(collection) {

    if (collection.id === 'SERVICE_TYPE') {
      // Use serviceTypes array instead of productSKUServiceTypeCollection
      // Sort by groupOrder first, then by serviceType name
      this.serviceTypeResults = [...JSON.parse(JSON.stringify(this.serviceTypes))];
      // Adjust groupOrder for fittings
      this.serviceTypeResults.forEach(serviceType => {
        if (serviceType.isFitting) {
          serviceType.groupOrder = serviceType.groupOrder - 10;
        }
        const totalPrice = serviceType.overrideSKUPrice ? serviceType.cost : serviceType.linkedSKUs?.reduce((sum, sku) => {
          return sum + ((this.vatInclusive ? sku.unitPrice_IncludingTax : sku.unitPrice) || 0);
        }, 0) || serviceType.cost || 0;


        serviceType.totalPrice = totalPrice;
        serviceType.skuNames = serviceType.linkedSKUs?.map(sku => sku.name || sku.sku).join(', ') || '';
      });


      this.serviceTypeResults.sort((a, b) => {
        // First sort by groupOrder
        if (a.groupOrder !== b.groupOrder) {
          return a.groupOrder - b.groupOrder;
        }
        // Then by serviceType name
        return a.serviceType.localeCompare(b.serviceType);
      });
      this.serviceTypeList = [...this.serviceTypeResults];      
      this.lineItemResults = [];
    } else if (collection.id === 'ALL') {
      this.lineItemResults = [];
      this.serviceTypeResults = [];
      this.serviceTypeList = [];
    } else {
      this.serviceTypeResults = [];
      this.serviceTypeList = [];
      this.isProductsloading = true;
      const selectedCollection = this.createdCollections.find(col => col.id === collection.id);
      this.invoiceService.getProductCollectionData(this.helpersService.getPartnerId(), selectedCollection.id).subscribe((result) => {
        this.workshopJobcardCreateService.convertToUpperCase(result);
        this.selectedCollectionData = (result || []).map((item) => ({ ...item, ProductCollectionLinkID: item.ID, ID: null }));
        this.lineItemResults = this.selectedCollectionData.slice().sort((a, b) => a.Name.localeCompare(b.Name));
        this.isProductsloading = false;
      }, err => {
        this.isProductsloading = false;
        console.error('Error fetching collection data:', err);
      });
    }
    this.selectedCollection = collection;
  }

  addToCollection(event, sku) {

    event.stopPropagation();

    if (!this.createdCollections || this.createdCollections.length === 0) {
      this.createCollection(sku);
      return;
    }
    const modalRef = this.modalService.open(WorkshopJobcardSaveToCollectionComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window'
    });

    modalRef.componentInstance.collections = this.createdCollections;
    modalRef.componentInstance.sku = sku;
    modalRef.componentInstance.manageCollections.subscribe(() => {
      this.manageCollections();
    });

    modalRef.result.then(
      (result) => {
        this.getCollections();
      },
      (onrejected) => {
        this.getCollections();
      },
    );
  }

  removeFromCollection(event, sku) {
    event.stopPropagation();
    this.invoiceService.deleteProductCollectionLink(sku.PartnerID, sku.ProductCollectionLinkID).subscribe((result) => {
      this.getCollectionSkus(this.selectedCollection);
      var index = this.createdCollections.findIndex((col) => col.id === this.selectedCollection.id);
      if (index > -1) {
        this.createdCollections[index].count = this.createdCollections[index].count - 1;
      }
      index = this.collections.findIndex((col) => col.id === this.selectedCollection.id);
      if (index > -1) {
        this.collections[index].count = this.collections[index].count - 1;
      }
      index = this.overflowCollections.findIndex((col) => col.id === this.selectedCollection.id);
      if (index > -1) {
        this.overflowCollections[index].count = this.overflowCollections[index].count - 1;
      }
    });
  }


  addToQuote(item) {
    if (!this.jobcard.quote) {
      this.jobcard.quote = { lineItems: [] }
    }
    if (!this.jobcard.quote.lineItems) {
      this.jobcard.quote.lineItems = [];
    }


    var linkedServiceTypesAdded = false;

    if (this.productSKUServiceTypeCollection.findIndex((serviceTypeSKU) => serviceTypeSKU.InternalProductID === item.InternalProductID) > -1) {
      var index = this.productSKUServiceTypeCollection.findIndex((serviceTypeSKU) => serviceTypeSKU.InternalProductID === item.InternalProductID);
      if (this.productSKUServiceTypeCollection[index].LinkedServiceTypes && this.productSKUServiceTypeCollection[index].LinkedServiceTypes.length > 0) {
        item.LinkedServiceTypes = this.productSKUServiceTypeCollection[index].LinkedServiceTypes;
        this.productSKUServiceTypeCollection[index].LinkedServiceTypes.forEach((serviceType) => {
          //if (this.jobcard.selectedServiceTypes.findIndex((st) => st.serviceTypeID === serviceType.serviceTypeID) === -1) {
          //this.jobcard.selectedServiceTypes.push(serviceType);
          if (!this.jobcard.id || this.partnerData?.AllowQuoteToUpdateServiceTypes) {
            this.jobcard.selectedServiceTypes = [...(this.jobcard.selectedServiceTypes || []), serviceType];
            linkedServiceTypesAdded = true;
          }
        });
      }
    }

    if (this.jobcard.quote.lineItems.findIndex((lineItem) => lineItem.InternalProductID === item.InternalProductID && !lineItem.IsLabor) === -1) {
      item.SKU = item.Sku || item.SKU;
      this.jobcard.quote.lineItems.push({ ...item, Quantity: 1 });
    } else {
      const index = this.jobcard.quote.lineItems.findIndex((lineItem) => lineItem.InternalProductID === item.InternalProductID);
      this.jobcard.quote.lineItems[index] = { ...this.jobcard.quote.lineItems[index], Quantity: this.jobcard.quote.lineItems[index].Quantity + 1, HasBeenUpdated: true };
    }

    if (!this.jobcard.id && linkedServiceTypesAdded) {
      // New jobcard only: the added SKU is linked to one or more service types, so
      // re-run availability to reallocate the technician + slot for the updated work.
      // (Plain SKUs with no linked service type don't change the work, so no reallocation.)
      this.reallocateTechnicianForNewJob();
    }

    this.clearSearchResults();
    this.searchProductTerm = '';
    this.searchBar.focusInput();
    this.jobcard = { ...this.jobcard };
    this.jobcardChange.emit({ ...this.jobcard });
  }

  addServiceTypeToQuote(serviceType: any) {
    if (!this.jobcard.quote) {
      this.jobcard.quote = { lineItems: [] };
    }
    if (!this.jobcard.quote.lineItems) {
      this.jobcard.quote.lineItems = [];
    }

    // Add all linked SKUs from the service type to the quote
    if (serviceType.linkedSKUs && serviceType.linkedSKUs.length > 0) {
      serviceType.linkedSKUs.forEach(sku => {
        const lineItem = {
          InternalProductID: sku.internalProductID,
          SKU: sku.sku,
          Name: sku.name,
          UnitPrice: sku.unitPrice,
          Tax: sku.tax,
          Taxable: sku.taxable,
          TaxRate: sku.taxRate,
          UnitPrice_IncludingTax: sku.unitPrice_IncludingTax,
          ExternalProductID: sku.externalProductID,
          Discountable: sku.discountable,
          NonInventory: sku.nonInventory,
          Brand: sku.brand,
          Type: sku.type,
          Ean: sku.ean,
          Upc: sku.upc,
          ManufacturerSKU: sku.manufacturerSKU,
          SystemSKU: sku.systemSKU,
          PartnerID: this.helpersService.getPartnerId(),
          LinkedServiceTypes: [serviceType],
          MarkedAsLabourProduct: sku.markedAsLabourProduct
        };

        // Check if item already exists in quote
        const existingIndex = this.jobcard.quote.lineItems.findIndex(
          (item) => item.InternalProductID === lineItem.InternalProductID
        );

        if (existingIndex === -1) {
          this.jobcard.quote.lineItems.push({ ...lineItem, Quantity: 1 });
        } else {
          this.jobcard.quote.lineItems[existingIndex] = {
            ...this.jobcard.quote.lineItems[existingIndex],
            Quantity: this.jobcard.quote.lineItems[existingIndex].Quantity + 1,
            HasBeenUpdated: true
          };
        }
      });
    }

    // Add the service type to selected service types
    if (!this.jobcard.selectedServiceTypes) {
      this.jobcard.selectedServiceTypes = [];
    }

    const existingServiceType = this.jobcard.selectedServiceTypes.find(
      st => st.serviceTypeID === serviceType.serviceTypeID
    );

    if (!existingServiceType) {
      this.jobcard.selectedServiceTypes.push({
        serviceTypeID: serviceType.serviceTypeID,
        partnerID: serviceType.partnerID,
        groupName: serviceType.groupName,
        serviceType: serviceType.serviceType,
        groupOrder: serviceType.groupOrder,
        show: serviceType.show,
        isFitting: serviceType.isFitting,
        hours: serviceType.hours,
        cost: serviceType.cost,
        overrideSKUPrice: serviceType.overrideSKUPrice
      });
    }

    if(this.jobcard.id && (!serviceType.linkedSKUs || serviceType.linkedSKUs.length === 0)){
      //Commit this to the backend 
      var data = {
        ...this.jobcard,
        scheduleDate: moment(this.jobcard.scheduleDate).format("YYYY-MM-DDTHH:mm:ss"),
        requiredByDate: this.jobcard.requiredByDate ? moment(this.jobcard.requiredByDate).format("YYYY-MM-DDTHH:mm:ss") : null,
      };
      this.serviceRequest.updateWorkshopJobCard(data).subscribe((result) => {

      });
    }

    if (!this.jobcard.id) {
      // New jobcard only: re-run workshop availability so the technician + open
      // time slot are reallocated for the updated service types. Existing jobcards
      // are intentionally left untouched here (mirrors workshop-jobcard-booking-details).
      this.reallocateTechnicianForNewJob();
    }

    this.clearSearchResults();
    this.searchProductTerm = '';
    this.searchBar.focusInput();
    this.jobcard = { ...this.jobcard };
    this.jobcardChange.emit({ ...this.jobcard });
  }

  // Re-queries Partner/{PartnerID}/Workshop/Availability for NEW jobcards only and
  // applies the resolved technician + schedule slot. This component has no technician
  // dropdown, so it passes an empty technicians list; jobcard.technician is still
  // resolved from the API result by WorkshopJobcardCreateService.getAvailableSlots.
  //
  // allocateFirstAvailable=true is required: unlike booking-details, this screen does
  // not pre-seed scheduleDate to an available slot, so the booking date often has no
  // matching availability. Passing true selects the first available slot on/after the
  // booking date (the closest forward slot) instead of forcing an unavailable date.
  private reallocateTechnicianForNewJob(): void {
    // Hard guard: never touch an existing jobcard from this path.
    if (this.jobcard.id) {
      return;
    }
    // When both originalTechnician and originalScheduleDate are present the tech + date
    // were explicitly chosen from the calendar — never override either regardless of the
    // selected service types.
    if (this.jobcard.originalTechnician && this.jobcard.originalScheduleDate) {
      return;
    }

    const selectedServiceTypeIDs = (this.jobcard.selectedServiceTypes || [])
      .map((st) => st.serviceTypeID)
      .filter((id) => id != null);

    // Enforce the technician the job was booked against from the calendar
    // (originalTechnician) when set; getAvailableSlots falls back to best-fit only when
    // it is absent or that technician can't do the selected work.
    this.workshopJobcardCreateService
      .getAvailableSlots(this.jobcard, selectedServiceTypeIDs, [], false, true, true, this.jobcard.originalTechnician || 0)
      .subscribe({
        next: (result) => {
          if (result && result.jobcard) {
            this.jobcard = { ...result.jobcard };
            this.jobcardChange.emit({ ...this.jobcard });
          }
        },
        error: (error) => {
          console.error('Error reallocating technician for new jobcard:', error);
        }
      });
  }

  getFilteredSKUs() {
    return this.lineItemResults;
  }

  onSearchChange() {
    var searchValue = this.searchProductTerm;
    if (this.selectedCollection && this.selectedCollection.id !== 'ALL') {
      if (this.selectedCollection.id === 'SERVICE_TYPE') {
        this.serviceTypeResults = this.serviceTypeList.filter((item) => {
          return item.serviceType.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.groupName.toLowerCase().includes(searchValue.toLowerCase());
        });
      } else {
        this.lineItemResults = this.selectedCollectionData.filter((item) => {
          return item.Name.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.SKU.toLowerCase().includes(searchValue.toLowerCase());
        });
      }
    } else {
      if (!searchValue || searchValue.length === 0) {
        this.lineItemResults = [];
      }
      this.searchSubject.next(searchValue); // Push new value to debounce
    }
  }




  getSearchResultQuantities(resetSearch = false) {
    if (!this.getQuantitiesLocked) {
      if (this.lineItemResults && this.lineItemResults.length < 100) {
        this.getQuantitiesLocked = true;
        var results = resetSearch
          ? JSON.parse(JSON.stringify(this.lineItemResults))
          : this.lineItemResults;
        if (this.canGetQuantitiesFromPOS) {
          this.productsService
            .GetInventoryOnHandForProducts(
              this.helpersService.getPartnerId(),
              results.map((x) => {
                return x.SKU;
              }),
            )
            .subscribe((queryResults) => {
              queryResults.forEach((stockItem) => {
                var searchItem = results
                  .filter((x) => {
                    return x.SKU === stockItem.SKU;
                  })
                  .pop();
                if (searchItem !== null && searchItem !== undefined && searchItem !== null) {
                  searchItem.StockOnHand = stockItem.isInventory
                    ? stockItem.QOH
                    : null;
                }
              });
              if (resetSearch) {
                this.lineItemResults = [];
              }
              this.lineItemResults = results.sort((x, y) => {
                if (x.StockOnHand < y.StockOnHand) return 1;
                if (x.StockOnHand > y.StockOnHand) return -1;
                return 0;
              });
              this.getQuantitiesLocked = false;

            }, err => {
              this.getQuantitiesLocked = false;
            });
        }
      }
    } else {
      setTimeout(() => {
        this.getSearchResultQuantities(resetSearch);
      }, 1000);
    }

    event.preventDefault();
  }


  searchAPI(searchValue: string = "", initialSearch: boolean = true) {
    this.isProductsloading = true;
    if (this.selectedExInOption.value == 'INTERNAL') {
      this.productsService
        .searchProductV2(this.helpersService.getPartnerId(), searchValue)
        .subscribe(
          (results) => {



            if (results.ExactMatch && this.partnerData.AllowExactMatchingOnQuote && results.products && results.products.length === 1) {

              if (!results.products[0].Data.toLowerCase().includes(searchValue.toLowerCase())) {

                var lineItem = {
                  InternalProductID: results.products[0].ID,
                  SKU: results.products[0].Description,
                  Name: results.products[0].Data,
                  UnitPrice: results.products[0].UnitPrice,
                  UnitPrice_IncludingTax: results.products[0].UnitPrice_IncludingTax,
                  Tax: results.products[0].Tax,
                  Type: results.products[0].Type,
                  Taxable: results.products[0].Taxable,
                  NonInvenotry: results.products[0].NonInventory,
                  Quantity: null,
                  ExternalProductID: results.products[0].ExternalProductID,
                  LineItemNote: null,
                  MarkedAsLabourProduct: results.products[0].MarkedAsLabourProduct
                };
                this.addToQuote(lineItem);
                this.searchProductTerm = '';
                this.isProductsloading = false;
                return;
              }

            }

            if (results && results.products) {
              this.lineItemResults = results.products.map((item) => {
                return {
                  InternalProductID: item.ID,
                  SKU: item.Description,
                  Name: item.Data,
                  UnitPrice: item.UnitPrice,
                  UnitPrice_IncludingTax: item.UnitPrice_IncludingTax,
                  Tax: item.Tax,
                  Type: item.Type,
                  Taxable: item.Taxable,
                  NonInvenotry: item.NonInventory,
                  Quantity: null,
                  ExternalProductID: item.ExternalProductID,
                  LineItemNote: null,
                  MarkedAsLabourProduct: item.MarkedAsLabourProduct
                };
              }).sort((a, b) => a.Name.localeCompare(b.Name));
            }

            if ((!results?.products || results.products.length === 0) && initialSearch) {
              this.searchAPI(this.searchProductTerm.substring(0, this.searchProductTerm.length - 1), false);
            }

            this.isProductsloading = false;

          },
          (err) => {
            this.isProductsloading = false;
          },
        );
    } else if (this.selectedExInOption.value == 'EXTERNAL') {
      this.productsService
        .searchExternalProduct(this.helpersService.getPartnerId(), searchValue)
        .subscribe(
          (results) => {
            if (results && results.products) {
              this.lineItemResults = JSON.parse(
                JSON.stringify(results.products),
              ).map((product) => {
                product.SupplierID = product.PartnerID;
                product.InternalProductID = JSON.parse(
                  JSON.stringify(product),
                ).ID;
                product.ID = 0;
                product.Quantity = 1;
                product.Discount = 0;
                product.DiscountID = 0;
                product.FoundInPOS = true;
                product.OriginalUnitPrice = JSON.parse(
                  JSON.stringify(product),
                ).UnitPrice;
                delete product.PartnerID;
                return product;
              });
            } else {
              this.lineItemResults = [];
            }
            this.isProductsloading = false;
          },
          error => {
            console.log(error)
            this.isProductsloading = false;
          }
        )
    }
  }

  searchExternal() { }


  getItemPricesGroups() {
    if (this.jobcard.id) {
      this.invoiceService
        .getItemPricesGroups(this.jobcard.partnerID)
        .subscribe((results) => {
          if (results && results.ProductGroups) {
            results.ProductGroups.forEach((x) => {
              this.priceGroups.push({ value: x.ID, label: x.Name });
            });
          }
        });
    }
  }

  updateLineItemPricesByGroup() {
    this.workshopJobcardQuoteService.updateLineItemPricesByGroup(
      this.jobcard,
      this.priceGroup,
      () => { },
      () => { }
    ).subscribe(
      () => {
        this.workshopJobcardQuoteService.manageInvoicePOSExtras(this.jobcard, true);
      }
    );
  }

  syncProducts() {
    this.syncingPOS = true;

    this.productsService.getAllProducts(this.helpersService.getPartnerId()).subscribe(
      (products) => {
        this.helpersService.saveProductData(products);
        this.syncingPOS = false;
      },
      (err) => {
        this.syncingPOS = false;
      },
    );
  }

  createSKU() {
    var partner = this.helpersService.getPartnerData();
    if (partner.POSSystemID <= 0) {
      const modalRef = this.modalService.open(WorkshopJobcardCreateSkuComponent, {
        backdrop: true,
        backdropClass: 'jobcard-modal-popup-backdrop',
        windowClass: 'jobcard-modal-popup-window'
      });
      modalRef.componentInstance.jobcard = this.jobcard;
      modalRef.result.then(
        (result) => {
          this.searchProductTerm = result.name;
          this.searchAPI(this.searchProductTerm);
          this.messageService.add({
            detail: this.translate.instant("bikeshop.workshop.jobcard.quote.new_product_added"),
            life: 5000
          });
        },
        (onrejected) => {

        },
      );
    } else {
      this.showCreatePOSProduct = true;
    }
  }

  posProductCreated(event: any) {
    console.log('POS Product Created:', event);
    this.showCreatePOSProduct = false;
    this.searchProductTerm = event.Name;
    this.searchAPI(this.searchProductTerm);
    this.messageService.add({
      detail: this.translate.instant("bikeshop.workshop.jobcard.quote.new_product_added"),
      life: 5000
    });
  }

  getDurationFormatted(duration: number) {
    return this.workshopJobcardQuoteService.getDurationFormatted(duration);
  }

}
